module.exports = __webpack_public_path__ + "static/media/hbp_care.9f3eb861.jpg";